var exports = {
  "YL": "prev-cVZqb",
  "K2": "next-cVZqb",
  "xJ": "sliderContainer-cVZqb",
  "nN": "indicatorContainer-cVZqb",
  "Q3": "activeIndicator-cVZqb",
  "MU": "overlayContainer-cVZqb",
  "hQ": "contentContainer-cVZqb",
  "Tg": "textArea-cVZqb",
  "L1": "category-cVZqb",
  "gy": "fadeInRight-cVZqb",
  "DD": "title-cVZqb",
  "h_": "description-cVZqb",
  "tE": "fadeInUp-cVZqb",
  "MY": "page-cVZqb",
  "yK": "imgBackground-cVZqb",
  "jZ": "slideInDown-cVZqb",
  "OY": "slideInUp-cVZqb",
  "K0": "slideInLeft-cVZqb",
  "xA": "slideInRight-cVZqb",
};

module.exports = exports;
